const costReg = /^-?\d{1,2}$/;
export const goodsTableDetils =
  [
    {
      title: '货主货品编码',
      dataIndex: 'skuCode',
      key: 'skuCode',
      width: 170
    },
    {
      title: '货品名称',
      dataIndex: 'skuName',
      key: 'skuName',
      scopedSlots: { customRender: 'skuName' },
      width: 190
    },
    {
      title: '货品基础规格',
      dataIndex: 'skuNorms',
      key: 'skuNorms',
      width: 100
    },
    {
      slots: { title: 'numberTitle' },
      dataIndex: 'number',
      key: 'number',
      width: 150,
      scopedSlots: { customRender: 'number' },
    },
    {
      slots: { title: 'companyTitle' },
      dataIndex: 'skuUnit',
      key: 'skuUnit',
      width: 100,
      scopedSlots: { customRender: 'skuUnit' },
    },
    {
      title: '可用库存',
      dataIndex: 'availableAmount',
      key: 'availableAmount',
      width: 110,
      ellipsis: true,
      scopedSlots: { customRender: 'availableAmount' },
    },
    {
      title: '指定批次',
      dataIndex: 'chooseBatch',
      key: 'chooseBatch',
      width: 300,
      scopedSlots: { customRender: 'chooseBatch' },
    },
    {
      title: '指定库位',
      dataIndex: 'storehouseId',
      key: 'storehouseId',
      width: 270,
      scopedSlots: { customRender: 'storehouseId' },
    },
    {
      title:'预计存储时长(天)',
      dataIndex: 'storageDuration',
      key: 'storageDuration',
      width: 120,
      scopedSlots: { customRender: 'storageDuration' },
    },
    {
      title:'生产日期要求',
      dataIndex: 'productTime',
      key: 'productTime',
      width: 150,
      scopedSlots: { customRender: 'productTime' },
    },
    // {
    //   title:'保质期要求(天)',
    //   dataIndex: 'shelfLifeDays',
    //   key: 'shelfLifeDays',
    //   width: 120,
    //   scopedSlots: { customRender: 'shelfLifeDays' },
    // },
    // {
    //   title: '指定条件',
    //   dataIndex: 'specifyConditions',
    //   key: 'specifyConditions',
    //   width: 150,
    //   scopedSlots: { customRender: 'specifyConditions' },
    // },
    // {
    //   title: '货品质量',
    //   dataIndex: 'designatedGoodsQuality',
    //   key: 'designatedGoodsQuality',
    //   width: 150,
    //   scopedSlots: { customRender: 'designatedGoodsQuality' },
    // },
    // {
    //   title: '指定批次',
    //   dataIndex: 'stockBatch',
    //   key: 'stockBatch',
    //   width: 90,
    //   scopedSlots: { customRender: 'stockBatch' },
    // },
    // {
    //   title: '生产日期',
    //   dataIndex: 'productTime',
    //   key: 'productTime',
    //   width: 160,
    //   scopedSlots: { customRender: 'productTime' },
    // },
    // {
    //   title: '是否越库',
    //   dataIndex: 'isOverWarehouse',
    //   key: 'isOverWarehouse',
    //   width: 100,
    //   scopedSlots: { customRender: 'isOverWarehouse' },
    // },
    {
      slots: { title: 'weightTitle' },
      dataIndex: 'weight',
      key: 'weight',
      width: 150,
      scopedSlots: { customRender: 'weight' },
    },
    {
      slots: { title: 'volumeTitle' },
      dataIndex: 'volume',
      key: 'volume',
      width: 150,
      scopedSlots: { customRender: 'volume' },
    },
    {
      slots: { title: 'temperatureZoneTitle' },
      dataIndex: 'temperatureZone',
      key: 'temperatureZone',
      width: 320,
      scopedSlots: { customRender: 'temperatureZone' },
    },
    {
      title: '操作',
      dataIndex: 'caozuo',
      key: 'caozuo',
      width: 160,
      fixed: 'right',
      scopedSlots: { customRender: 'caozuo' },
    },
  ]

export const goodsRules = {
  number: {
    RULES: [
      { required: true, message: '请输入数量', trigger: 'change' },
    ]
  },
  weight: {
    RULES: [
      { required: true, message: '请输入总重量', trigger: 'change' },
    ]
  },
  volume: {
    RULES: [
      { required: true, message: '请输入总体积', trigger: 'change' },
    ]
  },
  temperatureZone: {
    RULES: [
      { required: true, message: '请输入总体积', trigger: 'change' },
    ]
  },
  skuUnit: {
    RULES: [
      { required: true, message: '请选择单位', trigger: 'change' },
    ]
  },
  storageDuration: {
    RULES: [
      { pattern: /^(?!0)(?:[1-9][0-9]{0,3}|9999)$/, message: '范围为1-9999', trigger: 'change' },
    ]
  },
  // shelfLifeDays: {
  //   RULES: [
  //     { pattern: /^(?!0)(?:[1-9][0-9]{0,3}|9999)$/, message: '范围为1-9999', trigger: 'change' },
  //   ]
  // },
  lowtemp: {
    RULES: [
      { required: true, message: '请输入', trigger: 'change' },
      // { type: 'number', message: '请输入数字', trigger: 'change' },
      { pattern: costReg, message: '范围为-99至99', trigger: 'change' },
    ]
  },
  hightemp: {
    RULES: [
      { required: true, message: '请输入', trigger: 'change' },
      // { type: 'number', message: '请输入数字', trigger: 'change' },
      { pattern: costReg, message: '范围为-99至99', trigger: 'change' },
    ]
  },
}

export const goodsTableType = [
  {
    slots: { title: 'skuIdTitle' },
    dataIndex: 'skuId',
    key: 'skuId',
    scopedSlots: { customRender: 'skuId' },
    width: 200,
  },
  {
    title: '货品计量整单位',
    dataIndex: 'skuUnit',
    key: 'skuUnit',
    width: 120,
    scopedSlots: { customRender: 'skuUnit' },
  },
  {
    slots: { title: 'numberTitle' },
    dataIndex: 'number',
    key: 'number',
    width: 150,
    scopedSlots: { customRender: 'number' },
  },
  {
    slots: { title: 'weightTitle' },
    dataIndex: 'weight',
    key: 'weight',
    width: 150,
    scopedSlots: { customRender: 'weight' },
  },
  {
    slots: { title: 'volumeTitle' },
    dataIndex: 'volume',
    key: 'volume',
    width: 150,
    scopedSlots: { customRender: 'volume' },
  },
  {
    slots: { title: 'temperatureZoneTitle' },
    dataIndex: 'temperatureZone',
    key: 'temperatureZone',
    scopedSlots: { customRender: 'temperatureZone' },
    width: 320
  },
  {
    title: '总货值(元)',
    dataIndex: 'goodsValue',
    key: 'goodsValue',
    scopedSlots: { customRender: 'goodsValue' },
  },
  {
    title: '操作',
    dataIndex: 'caozuo',
    key: 'caozuo',
    scopedSlots: { customRender: 'caozuo' },
    width: 150
  },
]

export const goodsTypeRules = {
  skuId: {
    RULES: [
      { required: true, message: '请选择货品品类', trigger: 'change' },
    ]
  },
  skuUnit: {
    MAX_LENGTH: 30, // 最大长度
    RULES: [
    ]
  },
  number: {
    MAX_LENGTH: 30, // 最大长度
    RULES: [
      { required: true, message: '请输入数量', trigger: 'change' },
    ]
  },
  weight: {
    MAX_LENGTH: 30, // 最大长度
    RULES: [
      { required: true, message: '请输入总重量', trigger: 'change' },
    ]
  },
  volume: {
    MAX_LENGTH: 30, // 最大长度
    RULES: [
      { required: true, message: '请输入总体积', trigger: 'change' },
    ]
  },
  temperatureZone: {
    RULES: [
      { required: true, message: '请选择温区', trigger: 'change' },
    ]
  },
  goodsValue: {
    RULES: [
    ]
  },
}

export const goodsTableListColumns = [
  {
    title: '货主货品编码',
    dataIndex: 'skuCode',
    key: 'skuCode',
    scopedSlots: { customRender: 'skuCode' },
    width: 120,
    ellipsis: true,
  },
  {
    title: '货品名称',
    dataIndex: 'skuName',
    key: 'skuName',
    scopedSlots: { customRender: 'skuName' },
    width: 190,
    ellipsis: true,
  },
  {
    title: '默认单位',
    dataIndex: 'defaultUnit',
    key: 'defaultUnit',
    scopedSlots: { customRender: 'defaultUnit' },
    width: 80,
  },
  {
    title: '货品基础规格',
    dataIndex: 'norms',
    key: 'norms',
    scopedSlots: { customRender: 'norms' },
    width: 130,
  },
  {
    title: '整单位/零单位*换算率',
    dataIndex: 'wholeUnit',
    key: 'wholeUnit',
    scopedSlots: { customRender: 'wholeUnit' },
    width: 140,
  },
  {
    title: '整单位重量(kg)',
    dataIndex: 'weight',
    key: 'weight',
    scopedSlots: { customRender: 'weight' },
    width: 150,
  },
  {
    title: '货品体积(M³)',
    dataIndex: 'volume',
    key: 'volume',
    scopedSlots: { customRender: 'volume' },
    width: 150,
  },
  {
    title: '温区',
    dataIndex: 'temperatureZone',
    key: 'temperatureZone',
    scopedSlots: { customRender: 'temperatureZone' },
    width: 80,
  },
  {
    title: '货品单件含税价（元）',
    dataIndex: 'goodsPrice',
    key: 'goodsPrice',
    scopedSlots: { customRender: 'goodsPrice' },
    width: 120,
  },
]

// 仓配出库
export const goodsTableListColumnsOut = [
  {
    title: '货主货品编码',
    dataIndex: 'shipperGoodsCode',
    key: 'shipperGoodsCode',
    scopedSlots: { customRender: 'shipperGoodsCode' },
    width: 120,
    ellipsis: true,
  },
  {
    title: '货品名称',
    dataIndex: 'goodsName',
    key: 'goodsName',
    scopedSlots: { customRender: 'goodsName' },
    width: 190,
    ellipsis: true,
  },
  {
    title: '默认单位',
    dataIndex: 'defaultUnit',
    key: 'defaultUnit',
    scopedSlots: { customRender: 'defaultUnit' },
    width: 80,
    ellipsis: true,
  },
  {
    title: '整单位/换算率*零单位',
    dataIndex: 'wholeUnit',
    key: 'wholeUnit',
    scopedSlots: { customRender: 'wholeUnit' },
    width: 140,
    ellipsis: true,
  },
  {
    title: '可用库存',
    dataIndex: 'availableAmount',
    key: 'availableAmount',
    width: 80,
    ellipsis: true,
  },
  {
    title: '整单位重量(kg)',
    dataIndex: 'singleWeight',
    key: 'singleWeight',
    scopedSlots: { customRender: 'weight' },
    width: 150,
    ellipsis: true,
  },
  {
    title: '货品体积(M³)',
    dataIndex: 'singleVolume',
    key: 'singleVolume',
    scopedSlots: { customRender: 'volumeOut' },
    width: 100,
    ellipsis: true,
  },
  {
    title: '温区',
    dataIndex: 'goodsTemperatureLayerName',
    key: 'temperatureZone',
    scopedSlots: { customRender: 'temperatureZone' },
    width: 100,
    ellipsis: true,
  },
  {
    title: '品类',
    dataIndex: 'goodsLevel',
    key: 'goodsLevel',
    scopedSlots: { customRender: 'goodsLevel' },
    width: 120,
    ellipsis: true,
  },
]

export const batchTableColumns = [
  {
    title: '批次号',
    dataIndex: 'batchNo',
    key: 'batchNo',
    width: 190,
  },
  {
    title: '可用库存',
    dataIndex: 'availableAmount',
    key: 'availableAmount',
    width: 170,
  },
  {
    title: '生产日期',
    dataIndex: 'productDate',
    key: 'productDate',
    width: 160,
    customRender: (text, record) => record.batchAttributes?.productDate,
  },
  {
    title: '到期日期',
    dataIndex: 'expireDate',
    key: 'expireDate',
    width: 160,
    customRender: (text, record) => record.batchAttributes?.expire_date,
  },
  {
    title: '入库日期',
    dataIndex: 'storeDate',
    key: 'storeDate',
    width: 160,
    customRender: (text, record) => record.batchAttributes?.store_date,
  },
  {
    title: '入库单号',
    dataIndex: 'storeNo',
    key: 'storeNo',
    width: 180,
    customRender: (text, record) => record.batchAttributes?.store_no,
  },
  {
    title: '柜号',
    dataIndex: 'boxNo',
    key: 'boxNo',
    width: 120,
    customRender: (text, record) => record.batchAttributes?.box_no,
  },
  {
    title: '客户批次',
    dataIndex: 'customerBatch',
    key: 'customerBatch',
    width: 120,
    customRender: (text, record) => record.batchAttributes?.customer_batch,
  },
  {
    title: '追溯码',
    dataIndex: 'traceCode',
    key: 'traceCode',
    width: 120,
    customRender: (text, record) => record.batchAttributes?.traceCode,
  },
  {
    title: '检验检疫文',
    dataIndex: 'inspectionQuarantineCode',
    key: 'inspectionQuarantineCode',
    width: 120,
    customRender: (text, record) => record.batchAttributes?.inspectionQuearantineCode,
  }
]

export const errBatchColumns = [
  {
    title: '货主货品编码',
    dataIndex: 'skuCode',
    key: 'skuCode',
    width: 140,
  },
  {
    title: '货品名称',
    dataIndex: 'skuName',
    key: 'skuName',
    width: 180,
  },
  {
    title: '站点地址',
    dataIndex: 'stationFullAddress',
    key: 'stationFullAddress',
    width: 160,
    scopedSlots: { customRender: 'stationFullAddress' },
  },
  {
    title: '可用库存',
    dataIndex: 'availableAmount',
    key: 'availableAmount',
    width: 100,
  },
  {
    slots: { title: 'numberTitle' },
    dataIndex: 'number',
    key: 'number',
    width: 150,
    scopedSlots: { customRender: 'number' },
  },
  {
    slots: { title: 'companyTitle' },
    dataIndex: 'skuUnit',
    key: 'skuUnit',
    width: 100,
    scopedSlots: { customRender: 'skuUnit' },
  },
  {
    title: '指定批次',
    dataIndex: 'stockBatch',
    key: 'stockBatch',
    width: 140,
    scopedSlots: { customRender: 'stockBatch' },
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 150,
    fixed: 'right',
    scopedSlots: { customRender: 'action' },
  },
]

export const BATCHLIST = [
  {
    value: 'productDate',
    label: '生产日期',
    type: 'a-date-picker',
    placeholder: '请选择生产日期',
    attributes:{
      getCalendarContainer:(triggerNode) => (triggerNode.parentElement)
    }
  },
  {
    value: 'expireDate',
    label: '到期日期',
    type: 'a-date-picker',
    placeholder: '请选择到期日期',
    attributes:{
      getCalendarContainer:(triggerNode) => (triggerNode.parentElement)
    }
  },
  {
    value: 'storeNo',
    label: '入库单号',
    type: 'a-input',
    placeholder: '请输入入库单号',
  },
  {
    value: 'boxNo',
    label: '柜号',
    type: 'a-input',
    placeholder: '请输入柜号',
  },
  {
    value: 'customerBatch',
    label: '客户批次',
    type: 'a-input',
    placeholder: '请输入客户批次',
  },
  {
    value: 'traceCode',
    label: '追溯码',
    type: 'a-input',
    placeholder: '请输入追溯码',
  },
  {
    value: 'inspectionQuarantineCode',
    label: '检验检疫文',
    type: 'a-input',
    placeholder: '请输入检验检疫文',
  },
  {
    value: 'batchSupperName',
    label: '供应商',
    type: 'a-select',
    placeholder: '请输入供应商',
    options: [],
    attributes:{
      getPopupContainer:(triggerNode) => (triggerNode.parentElement)
    }
  },
]

export const DROPMENU = [
  {
    value: 'batch',
    lable: '批属性',
  },
  {
    value: 'location',
    lable: '库位',
  },
  {
    value: 'quality',
    lable: '货品质量',
  }
]

export const BATCHPROPERTIES = [
  {
    value: 'productDate',
    label: '生产日期',
    type: 'a-date-picker',
    placeholder: '请选择生产日期',
  },
  {
    value: 'expireDate',
    label: '到期日期',
    type: 'a-date-picker',
    placeholder: '请选择到期日期',
  },
  {
    value: 'storeDate',
    label: '入库日期',
    type: 'a-date-picker',
    placeholder: '请选择入库时间',
  },
  {
    value: 'storeNo',
    label: '入库单号',
    type: 'a-input',
    placeholder: '请输入入库单号',
  },
  {
    value: 'boxNo',
    label: '柜号',
    type: 'a-input',
    placeholder: '请输入柜号',
  },
  {
    value: 'customerBatch',
    label: '客户批次',
    type: 'a-input',
    placeholder: '请输入客户批次',
  },
  {
    value: 'traceCode',
    label: '追溯码',
    type: 'a-input',
    placeholder: '请输入追溯码',
  },
  {
    value: 'inspectionQuarantineCode',
    label: '检验检疫文',
    type: 'a-input',
    placeholder: '请输入检验检疫文',
  },
]

export const BATCHPROPERTIES_TABLE = [
  {
    value: 'productDate',
    label: '生产日期',
    options:[{
      label:'2023-01-01',
      value:'2023-01-01'
    }]
  },
  {
    value: 'storeNo',
    label: '入库单号',
    options:[{
      label:'单号1',
      value:'312321'
    }]
  },
]

export const goodsQuality = [
  {
    value: 'GOOD',
    label: '良品',
  },
  {
    value: 'BAD',
    label: '不良品',
  },
  {
    value: 'SCRAP',
    label: '报废品',
  },
  {
    value: 'FROZEN',
    label: '冻结品',
  },
]


// 盘点货品表格配置
export const inventoryTableColumns = [
  {
      title: '货主货品编码',
      dataIndex: 'shipperGoodsCode',
      key: 'shipperGoodsCode',
      width: 190
    },
    {
      title: '货品名称',
      dataIndex: 'skuName',
      key: 'skuName',
      scopedSlots: { customRender: 'skuName' },
      width: 190
    },
    {
      title: '可用库存',
      dataIndex: 'availableStockStr',
      key: 'availableStockStr',
      width: 160,
      ellipsis: true,
      scopedSlots: { customRender: 'availableStockStr' },
    },
    {
      title: '温区',
      dataIndex: 'temperatureZone',
      key: 'temperatureZone',
      scopedSlots: { customRender: 'temperatureZone' },
      width: 120,
    },
    {
      title: '操作',
      dataIndex: 'caozuo',
      key: 'caozuo',
      width: 160,
      fixed: 'right',
      scopedSlots: { customRender: 'caozuo' },
    },
]